import React from "react";
import ProfileBox from "~/components/profile/ProfileBox";
import { Margin } from "~/components/spacings";
import * as palette from "@govlaunch/palette";
import ProjectsIcon from "~/components/icons/VendorProfile/ProjectsIcon";
import { FormattedMessage } from "react-intl";

export default function NoProjectConnectionsBox() {
  return (
    <ProfileBox>
      <div
        css={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 26,
        }}
      >
        <ProjectsIcon width={33} height={33} color={palette.mediumGray} />
        <Margin ml={14}>
          <span
            css={{
              fontSize: 18,
              fontWeight: 500,
              color: palette.mediumGray,
            }}
          >
            <FormattedMessage defaultMessage="No Project Connections" id="PVVUQM" />
          </span>
        </Margin>
      </div>
    </ProfileBox>
  );
}
